(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pandas-quote-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const field = document.getElementById('PandasQuoteSource');
    const service = document.getElementById('PandasQuoteService');
    if (!field) return;
    const params = new URLSearchParams(window.location.search);
    const product = params.get('product');
    const requestedService = params.get('service');
    const serviceNames = {
      'vehicle-wraps': 'Vehicle Wraps & Graphics',
      'signs-banners': 'Signs & Banners',
      'custom-apparel': 'Custom Apparel',
      'custom-stickers': 'Custom Stickers',
      'custom-menus': 'Custom Menus',
      'promotional-products': 'Promotional Products & Laser Engraving',
      'dtf-transfers': 'DTF Transfers',
      'laser-engraving': 'Promotional Products & Laser Engraving'
    };

    if (product) {
      field.value = product.replaceAll('-', ' ');
      if (service) service.value = 'Vehicle Wraps & Graphics';
    } else if (requestedService && serviceNames[requestedService]) {
      field.value = `Products & Services: ${serviceNames[requestedService]}`;
      if (service) service.value = serviceNames[requestedService];
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pandas-wraps-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pwr').forEach((section) => {
    const dialog = section.querySelector('.pwr__lightbox');
    const media = dialog?.querySelector('.pwr__lightbox-media');
    section.querySelectorAll('.pwr__photo').forEach((button) => {
      button.addEventListener('click', () => {
        const image = button.querySelector('img');
      if (!dialog || !media || !image) return;
      media.replaceChildren(image.cloneNode());
      const viewer = media.querySelector('img');
      viewer?.removeAttribute('loading');
      if (viewer) viewer.alt = image.alt;
        dialog.showModal();
      });
    });
    dialog?.querySelector('.pwr__lightbox-close')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  });

  } catch(e) { console.error(e); }
})();
})();
